import Superagent from 'superagent'
import Storage from './storage.service'
import Access from '../$methods/access.methods'

const { HOST_API } = _CONSTANTS_

export default {
    getZipcodeColony
}

function getZipcodeColony(zipcode) {
    return new Promise((resolve, reject) => {
        Superagent
            .get(`${HOST_API}/zipcodes/colony/${zipcode}`)
            .set('access', Storage.getItem('access'))
            .end((err, res) => {
                Access(res.body)
                resolve(res.body)
            })
    })
}